export const getSuggestions =  async(search) =>{
    if(search){
        return ["123" , "12333" , "123124141"];
    }

    return [];
}